module.exports = __webpack_public_path__ + "img/jianjietopmin.a71f1bd5.png";